<template>
    <vx-alert v-if="!props.available" color="info" :closeable="false" data-test="balance-unavailable">
        RND isn't available in this environment, so its remaining queries aren't shown.
    </vx-alert>

    <vx-alert v-else-if="failed" color="danger" :closeable="false" data-test="balance-failed">
        RND's remaining queries could not be loaded. Please reload the page to try again.
    </vx-alert>

    <dl v-else-if="balance" class="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
            <dt class="text-sm text-slate-500">RND queries remaining</dt>
            <dd class="text-lg font-bold" data-test="queries-remaining">
                {{ formatNumber(balance.queries_remaining) }}
                <span class="text-sm font-normal text-slate-500">of {{ formatNumber(balance.queries_allowed) }}</span>
            </dd>
        </div>
        <div>
            <dt class="text-sm text-slate-500">RND subscription ends</dt>
            <dd class="text-lg font-bold" data-test="subscription-end-date">{{ subscriptionEndDate }}</dd>
        </div>
    </dl>
</template>

<script lang="ts" setup>
import { VxAlert } from '@voxie/frontend-components';
import { computed, ref } from 'vue';
import { adminRndClient } from '~/services';
import type { RndBalance } from '~/services/adminRndClient.types';
import dayjs from '~/utils/dayjs';
import { formatNumber } from '~/utils/helpers';

const props = withDefaults(defineProps<{ available?: boolean }>(), { available: false });

const balance = ref<RndBalance>();
const failed = ref(false);

const subscriptionEndDate = computed(() => {
    const endDate = balance.value?.subscription_end_date ?? null;

    return endDate === null ? '-' : dayjs(endDate, 'YYYY-MM-DD').format('MMM D, YYYY');
});

if (props.available) {
    adminRndClient
        .getBalance()
        .then((response) => {
            balance.value = response.data;
        })
        .catch(() => {
            failed.value = true;
        });
}
</script>
